module.exports = new __parcel__URL__("octo-header-poster.jpg.d08ef889.webp").toString();